import React, {Component} from 'react';
import PropTypes from "prop-types";
import { withFormik, Form, Field } from 'formik';
import Yup from 'yup';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import {NotificationManager} from 'react-notifications';

/*

renderForm1 = ({
                         isReviewForm,
                         touched,
                        values,
                         errors,
                         isSubmitting,
                         handleSubmit,
                         collapsedForms,
                         collapseForm,
                         clearCollapseForms,
                         toggleCollapse,
                         setFieldValue, 
                         findError
                     }) => {
                     
                     */
class renderForm1 extends Component {
                     
    

    renderFirstNameForm = () => (
        <div className="col-sm-4">
            <div className={
                this.props.touched.name ?
                    (this.props.errors.name
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    First Name
                    <span className="required" aria-required="true">* </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="name"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.name
                    && this.props.errors.name
                    && <p className="help-block">
                        {this.props.errors.name}
                    </p>
                }
            </div>
        </div>
    );

    renderMiddleNameForm = () => (
        <div className="col-sm-4">
            <div className={
                this.props.touched.mname ?
                    (this.props.errors.mname
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Middle Name
                    <span className="required" aria-required="true"> </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="mname"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.mname
                    && this.props.errors.mname
                    && <p className="help-block">
                        {this.props.errors.mname}
                    </p>
                }
            </div>
        </div>
    );

    renderLastNameForm = () => (
        <div className="col-sm-4">
            <div className={
                this.props.touched.lname ?
                    (this.props.errors.lname
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Last Name
                    <span className="required" aria-required="true">* </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="lname"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.lname
                    && this.props.errors.lname
                    && <p className="help-block">
                        {this.props.errors.lname}
                    </p>
                }
            </div>
        </div>
    );

    renderEmailForm = () => (
        <div className="col-sm-4">
            <div className={
                this.props.touched.email ?
                    (this.props.errors.email
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Email Address
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="email"
                    className="form-control"
                    name="email"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.email
                    && this.props.errors.email
                    && <p className="help-block">
                        {this.props.errors.email}
                    </p>
                }
            </div>
        </div>
    );

    renderPhoneForm = () => (
        <div className="col-sm-3">
            <div className={
                this.props.touched.phone ?
                    (this.props.errors.phone
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Cell Number
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="tel"
                    className="form-control"
                    name="phone"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.phone
                    && this.props.errors.phone
                    && <p className="help-block">
                        {this.props.errors.phone}
                    </p>
                }
            </div>
        </div>
    );

    renderGenderForm = () => (
        <div className="col-sm-4">
            <div className={
                this.props.touched.gender ?
                    (this.props.errors.gender
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Gender
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    component='select'
                    className="form-control"
                    name="gender"
                    disabled={!!this.props.isReviewForm}
                >
                    <option value="">Choose</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                </Field>
                <span className="help-block"/>
                {
                    this.props.touched.gender
                    && this.props.errors.gender
                    && <p className="help-block">
                        {this.props.errors.gender}
                    </p>
                }
            </div>
        </div>
    );

    renderDobForm = () => (
        <div className="col-sm-4">
            {!!this.props.isReviewForm ?
                <div>
                    <label>
                        Date of Birth
                        <span
                            className="required"
                            aria-required="true">
                        *
                    </span>
                    </label>
                    <div>

                    {moment(this.props.values.birthdate).format('MMM DD YYYY')}</div>
                </div>

                :
                <div className={
                    this.props.touched.birthdate ?
                        (this.props.errors.birthdate
                            ? "has-error form-group"
                            : "has-success form-group")
                        : "form-group"
                }>
                    <label>
                        Date of Birth
                        <span
                            className="required"
                            aria-required="true">
                        *
                    </span>
                    </label>

                    <DatePicker
                        selected={moment(this.props.values.birthdate)}
                        name="birthdate"
                        className="form-control"
                        onChange={e => {
                            if(moment(e).diff(moment(), 'days') < 0){
                              this.props.setFieldValue('birthdate', e);
                              if(moment().diff(moment(e), 'years') < 18){
                                  this.props.setFieldValue('requireParent', "true");
                              }else{
                                  this.props.setFieldValue('requireParent', "false");
                              }
                                
                            }else{
                                NotificationManager.error('Select a past date');
                            }
                        }
                        }
                        onBlur={e => this.props.collapseForm(1)}
                        showMonthDropdown
                        showYearDropdown
                        dropdownMode="select"
                        yearDropdownItemNumber={15}
                    />
                            
                    {
                        this.props.touched.birthdate
                        && this.props.errors.birthdate
                        && <p className="has-error help-block">
                            {this.props.errors.birthdate}
                        </p>
                    }
                </div>
            }

        </div>
    );

    renderAddressForm = () => (
        <div className="col-sm-6">
            <div className={
                this.props.touched.address ?
                    (this.props.errors.address
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Address
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="address"
                    disabled={!!this.props.isReviewForm}
                />
                {
                        this.props.touched.address
                        && this.props.errors.address
                        && <p className="has-error help-block">
                            {this.props.errors.address}
                        </p>
                    }
            </div>
            </div>
        </div>
    );
    
    renderAddress2Form = () => (
        <div className="col-sm-6">
            <div className="form-group">
                <label>
                    Address Line 2 (Optional)
                    
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="address2"
                    disabled={!!this.props.isReviewForm}
                />
            </div>
        </div>
    );
    
    renderContactTypeForm = () => (
        <div className="col-sm-3">
        <div className={
                this.props.touched.phonetype ?
                    (this.props.errors.phonetype
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Contact Type
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    component="select"
                    className="form-control"
                    name="phonetype"
                    disabled={!!this.props.isReviewForm}
                >

                    <option value="">Choose</option>
                    <option value="Cell">Cell</option>
                    <option value="Home">Home</option>
                    <option value="Work">Work</option>
                    <option value="Other">Other</option>
                </Field>
                {
                    this.props.touched.phonetype
                    && this.props.errors.phonetype
                    && <p className="help-block">
                        {this.props.errors.phonetype}
                    </p>
                }
            </div>
            </div>
        </div>
    );
    
    
    renderContactCodeForm = () => (
        <div className="col-sm-2">
        <div className={
                this.props.touched.phonecountry ?
                    (this.props.errors.phonecountry
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Country Code
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="phonecountry"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.phonecountry
                    && this.props.errors.phonecountry
                    && <p className="help-block">
                        {this.props.errors.phonecountry}
                    </p>
                }
            </div>
            </div>
        </div>
    );
    
    
    renderContactNumberForm = () => (
        <div className="col-sm-4">
        <div className={
                this.props.touched.phone ?
                    (this.props.errors.phone
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Contact number
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="phone"
                    disabled={!!this.props.isReviewForm}
                    onBlur={e => this.props.collapseForm(3)}
                />
                {
                    this.props.touched.phone
                    && this.props.errors.phone
                    && <p className="help-block">
                        {this.props.errors.phone}
                    </p>
                }
            </div>
        </div>
        </div>
    );
    
    
    
    
    
    renderECTypeForm = () => (
        <div className="col-sm-3">
        <div className={
                this.props.touched.ectype ?
                    (this.props.errors.ectype
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Contact Type
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    component="select"
                    className="form-control"
                    name="ectype"
                    disabled={!!this.props.isReviewForm}
                >

                    <option value="">Choose</option>
                    <option value="Cell">Cell</option>
                    <option value="Home">Home</option>
                    <option value="Work">Work</option>
                    <option value="Other">Other</option>
                </Field>
                {
                    this.props.touched.ectype
                    && this.props.errors.ectype
                    && <p className="help-block">
                        {this.props.errors.ectype}
                    </p>
                }
            </div>
            </div>
        </div>
    );
    
    
    renderECCountryForm = () => (
        <div className="col-sm-2">
        <div className={
                this.props.touched.eccountry ?
                    (this.props.errors.eccountry
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Country Code
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="eccountry"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.eccountry
                    && this.props.errors.eccountry
                    && <p className="help-block">
                        {this.props.errors.eccountry}
                    </p>
                }
            </div>
        </div>
        </div>
    );
    
     
    renderECRelForm = () => (
        <div className="col-sm-3">
        <div className={
                this.props.touched.ecrel ?
                    (this.props.errors.ecrel
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Relationship
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    component="select"
                    className="form-control"
                    name="ecrel"
                    disabled={!!this.props.isReviewForm}
                >
            
                    <option value="">Choose</option>
                    <option value="Mother">Mother</option>
                    <option value="Father">Father</option>
                    <option value="Brother">Brother</option>
                    <option value="Other">Other</option>
                                                                                
                </Field>
                {
                    this.props.touched.ecrel
                    && this.props.errors.ecrel
                    && <p className="help-block">
                        {this.props.errors.ecrel}
                    </p>
                }
            </div>
        </div>
        </div>
    );
     
    renderECNameForm = () => (
        <div className="col-sm-6">
        <div className={
                this.props.touched.ecname ?
                    (this.props.errors.ecname
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Contact Name
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="ecname"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.ecname
                    && this.props.errors.ecname
                    && <p className="help-block">
                        {this.props.errors.ecname}
                    </p>
                }
            </div>
            </div>
        </div>
    );
    
    
    renderECNumberForm = () => (
        <div className="col-sm-4">
        <div className={
                this.props.touched.ecnumber ?
                    (this.props.errors.ecnumber
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
            <div className="form-group">
                <label>
                    Contact number
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="ecnumber"
                    disabled={!!this.props.isReviewForm}
                    onBlur={e => this.props.collapseForm(4)}
                />
                {
                    this.props.touched.ecnumber
                    && this.props.errors.ecnumber
                    && <p className="help-block">
                        {this.props.errors.ecnumber}
                    </p>
                }
            </div>
        </div>
        </div>
    );
    
    
    
    
    
    
    renderPTypeForm = () => (
        <div className="col-sm-3">
            <div className={
                this.props.touched.ptype ?
                    (this.props.errors.ptype
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Contact Type
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    component="select"
                    className="form-control"
                    name="ptype"
                    disabled={!!this.props.isReviewForm}
                >

                    <option value="">Choose</option>
                    <option value="Cell">Cell</option>
                    <option value="Home">Home</option>
                    <option value="Work">Work</option>
                    <option value="Other">Other</option>
                </Field>
            </div>
        </div>
    );
    
    
    renderPCountryForm = () => (
        <div className="col-sm-2">
            <div className={
                this.props.touched.pcountry ?
                    (this.props.errors.pcountry
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Country Code
                    
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="pcountry"
                    disabled={!!this.props.isReviewForm}
                />
            </div>
        </div>
    );
    
     
    renderPRelForm = () => (
        <div className="col-sm-3">
            <div className={
                this.props.touched.prel ?
                    (this.props.errors.prel
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Relationship
                    
                </label>
                <Field
                    component="select"
                    className="form-control"
                    name="prel"
                    disabled={!!this.props.isReviewForm}
                >
            
                    <option value="">Choose</option>
                    <option value="Mother">Mother</option>
                    <option value="Father">Father</option>
                    <option value="Brother">Brother</option>
                    <option value="Other">Other</option>
                                                                                
                </Field>
            </div>
        </div>
    );
     
    renderPNameForm = () => (
        <div className="col-sm-6">
            <div className={
                this.props.touched.pname ?
                    (this.props.errors.pname
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Contact Name
                    
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="pname"
                    disabled={!!this.props.isReviewForm}
                />
            </div>
        </div>
    );
    
    
    renderPNumberForm = () => (
        <div className="col-sm-4">
            <div className={
                this.props.touched.pnumber ?
                    (this.props.errors.pnumber
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Contact number
                    
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="pnumber"
                    disabled={!!this.props.isReviewForm}
                    onBlur={e => this.props.collapseForm(5)}
                />
            </div>
        </div>
    );
    
    
    
    renderReferrerForm = () => (
        <div className="col-sm-12">
            <div className="form-group">
                
                <Field
                    component="select"
                    className="form-control"
                    name="referrer"
                    disabled={!!this.props.isReviewForm}
                >

                   <option value="">Select</option>
                   
                    <option value="Heard from a friend">Heard from a friend</option>
                    <option value="Social Media (Facebook, Twitter, Instagram, Youtube, Other)">Social Media (Facebook, Twitter, Instagram, Youtube, Other)</option>
                    <option value="Email ">Email </option>
                    <option value="Online Search (Google/Bing/Other)">Online Search (Google/Bing/Other)</option>
 
                  </Field>
            </div>
        </div>
    );
    
    
    renderCountryForm = () => (
        <div className="col-sm-3">
            <div className={
                this.props.touched.country ?
                    (this.props.errors.country
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Country
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    component='select'
                    className="form-control"
                    name="country"
                    disabled={!!this.props.isReviewForm}
                >

                                                                                <option value="">Choose</option>
                                                                                <option value="AFG">Afghanistan</option>
                                                                                <option value="ALA">Åland Islands</option>
                                                                                <option value="ALB">Albania</option>
                                                                                <option value="DZA">Algeria</option>
                                                                                <option value="ASM">American Samoa</option>
                                                                                <option value="AND">Andorra</option>
                                                                                <option value="AGO">Angola</option>
                                                                                <option value="AIA">Anguilla</option>
                                                                                <option value="ATA">Antarctica</option>
                                                                                <option value="ATG">Antigua and Barbuda</option>
                                                                                <option value="ARG">Argentina</option>
                                                                                <option value="ARM">Armenia</option>
                                                                                <option value="ABW">Aruba</option>
                                                                                <option value="AUS">Australia</option>
                                                                                <option value="AUT">Austria</option>
                                                                                <option value="AZE">Azerbaijan</option>
                                                                                <option value="BHS">Bahamas</option>
                                                                                <option value="BHR">Bahrain</option>
                                                                                <option value="BGD">Bangladesh</option>
                                                                                <option value="BRB">Barbados</option>
                                                                                <option value="BLR">Belarus</option>
                                                                                <option value="BEL">Belgium</option>
                                                                                <option value="BLZ">Belize</option>
                                                                                <option value="BEN">Benin</option>
                                                                                <option value="BMU">Bermuda</option>
                                                                                <option value="BTN">Bhutan</option>
                                                                                <option value="BOL">Bolivia, Plurinational State of</option>
                                                                                <option value="BES">Bonaire, Sint Eustatius and Saba</option>
                                                                                <option value="BIH">Bosnia and Herzegovina</option>
                                                                                <option value="BWA">Botswana</option>
                                                                                <option value="BVT">Bouvet Island</option>
                                                                                <option value="BRA">Brazil</option>
                                                                                <option value="IOT">British Indian Ocean Territory</option>
                                                                                <option value="BRN">Brunei Darussalam</option>
                                                                                <option value="BGR">Bulgaria</option>
                                                                                <option value="BFA">Burkina Faso</option>
                                                                                <option value="BDI">Burundi</option>
                                                                                <option value="KHM">Cambodia</option>
                                                                                <option value="CMR">Cameroon</option>
                                                                                <option value="CAN">Canada</option>
                                                                                <option value="CPV">Cape Verde</option>
                                                                                <option value="CYM">Cayman Islands</option>
                                                                                <option value="CAF">Central African Republic</option>
                                                                                <option value="TCD">Chad</option>
                                                                                <option value="CHL">Chile</option>
                                                                                <option value="CHN">China</option>
                                                                                <option value="CXR">Christmas Island</option>
                                                                                <option value="CCK">Cocos (Keeling) Islands</option>
                                                                                <option value="COL">Colombia</option>
                                                                                <option value="COM">Comoros</option>
                                                                                <option value="COG">Congo</option>
                                                                                <option value="COD">Congo, the Democratic Republic of the</option>
                                                                                <option value="COK">Cook Islands</option>
                                                                                <option value="CRI">Costa Rica</option>
                                                                                <option value="CIV">Côte d'Ivoire</option>
                                                                                <option value="HRV">Croatia</option>
                                                                                <option value="CUB">Cuba</option>
                                                                                <option value="CUW">Curaçao</option>
                                                                                <option value="CYP">Cyprus</option>
                                                                                <option value="CZE">Czech Republic</option>
                                                                                <option value="DNK">Denmark</option>
                                                                                <option value="DJI">Djibouti</option>
                                                                                <option value="DMA">Dominica</option>
                                                                                <option value="DOM">Dominican Republic</option>
                                                                                <option value="ECU">Ecuador</option>
                                                                                <option value="EGY">Egypt</option>
                                                                                <option value="SLV">El Salvador</option>
                                                                                <option value="GNQ">Equatorial Guinea</option>
                                                                                <option value="ERI">Eritrea</option>
                                                                                <option value="EST">Estonia</option>
                                                                                <option value="ETH">Ethiopia</option>
                                                                                <option value="FLK">Falkland Islands (Malvinas)</option>
                                                                                <option value="FRO">Faroe Islands</option>
                                                                                <option value="FJI">Fiji</option>
                                                                                <option value="FIN">Finland</option>
                                                                                <option value="FRA">France</option>
                                                                                <option value="GUF">French Guiana</option>
                                                                                <option value="PYF">French Polynesia</option>
                                                                                <option value="ATF">French Southern Territories</option>
                                                                                <option value="GAB">Gabon</option>
                                                                                <option value="GMB">Gambia</option>
                                                                                <option value="GEO">Georgia</option>
                                                                                <option value="DEU">Germany</option>
                                                                                <option value="GHA">Ghana</option>
                                                                                <option value="GIB">Gibraltar</option>
                                                                                <option value="GRC">Greece</option>
                                                                                <option value="GRL">Greenland</option>
                                                                                <option value="GRD">Grenada</option>
                                                                                <option value="GLP">Guadeloupe</option>
                                                                                <option value="GUM">Guam</option>
                                                                                <option value="GTM">Guatemala</option>
                                                                                <option value="GGY">Guernsey</option>
                                                                                <option value="GIN">Guinea</option>
                                                                                <option value="GNB">Guinea-Bissau</option>
                                                                                <option value="GUY">Guyana</option>
                                                                                <option value="HTI">Haiti</option>
                                                                                <option value="HMD">Heard Island and McDonald Islands</option>
                                                                                <option value="VAT">Holy See (Vatican City State)</option>
                                                                                <option value="HND">Honduras</option>
                                                                                <option value="HKG">Hong Kong</option>
                                                                                <option value="HUN">Hungary</option>
                                                                                <option value="ISL">Iceland</option>
                                                                                <option value="IND">India</option>
                                                                                <option value="IDN">Indonesia</option>
                                                                                <option value="IRN">Iran, Islamic Republic of</option>
                                                                                <option value="IRQ">Iraq</option>
                                                                                <option value="IRL">Ireland</option>
                                                                                <option value="IMN">Isle of Man</option>
                                                                                <option value="ISR">Israel</option>
                                                                                <option value="ITA">Italy</option>
                                                                                <option value="JAM">Jamaica</option>
                                                                                <option value="JPN">Japan</option>
                                                                                <option value="JEY">Jersey</option>
                                                                                <option value="JOR">Jordan</option>
                                                                                <option value="KAZ">Kazakhstan</option>
                                                                                <option value="KEN">Kenya</option>
                                                                                <option value="KIR">Kiribati</option>
                                                                                <option value="PRK">Korea, Democratic People's Republic of</option>
                                                                                <option value="KOR">Korea, Republic of</option>
                                                                                <option value="KWT">Kuwait</option>
                                                                                <option value="KGZ">Kyrgyzstan</option>
                                                                                <option value="LAO">Lao People's Democratic Republic</option>
                                                                                <option value="LVA">Latvia</option>
                                                                                <option value="LBN">Lebanon</option>
                                                                                <option value="LSO">Lesotho</option>
                                                                                <option value="LBR">Liberia</option>
                                                                                <option value="LBY">Libya</option>
                                                                                <option value="LIE">Liechtenstein</option>
                                                                                <option value="LTU">Lithuania</option>
                                                                                <option value="LUX">Luxembourg</option>
                                                                                <option value="MAC">Macao</option>
                                                                                <option value="MKD">Macedonia, the former Yugoslav Republic of</option>
                                                                                <option value="MDG">Madagascar</option>
                                                                                <option value="MWI">Malawi</option>
                                                                                <option value="MYS">Malaysia</option>
                                                                                <option value="MDV">Maldives</option>
                                                                                <option value="MLI">Mali</option>
                                                                                <option value="MLT">Malta</option>
                                                                                <option value="MHL">Marshall Islands</option>
                                                                                <option value="MTQ">Martinique</option>
                                                                                <option value="MRT">Mauritania</option>
                                                                                <option value="MUS">Mauritius</option>
                                                                                <option value="MYT">Mayotte</option>
                                                                                <option value="MEX">Mexico</option>
                                                                                <option value="FSM">Micronesia, Federated States of</option>
                                                                                <option value="MDA">Moldova, Republic of</option>
                                                                                <option value="MCO">Monaco</option>
                                                                                <option value="MNG">Mongolia</option>
                                                                                <option value="MNE">Montenegro</option>
                                                                                <option value="MSR">Montserrat</option>
                                                                                <option value="MAR">Morocco</option>
                                                                                <option value="MOZ">Mozambique</option>
                                                                                <option value="MMR">Myanmar</option>
                                                                                <option value="NAM">Namibia</option>
                                                                                <option value="NRU">Nauru</option>
                                                                                <option value="NPL">Nepal</option>
                                                                                <option value="NLD">Netherlands</option>
                                                                                <option value="NCL">New Caledonia</option>
                                                                                <option value="NZL">New Zealand</option>
                                                                                <option value="NIC">Nicaragua</option>
                                                                                <option value="NER">Niger</option>
                                                                                <option value="NGA">Nigeria</option>
                                                                                <option value="NIU">Niue</option>
                                                                                <option value="NFK">Norfolk Island</option>
                                                                                <option value="MNP">Northern Mariana Islands</option>
                                                                                <option value="NOR">Norway</option>
                                                                                <option value="OMN">Oman</option>
                                                                                <option value="PAK">Pakistan</option>
                                                                                <option value="PLW">Palau</option>
                                                                                <option value="PSE">Palestinian Territory, Occupied</option>
                                                                                <option value="PAN">Panama</option>
                                                                                <option value="PNG">Papua New Guinea</option>
                                                                                <option value="PRY">Paraguay</option>
                                                                                <option value="PER">Peru</option>
                                                                                <option value="PHL">Philippines</option>
                                                                                <option value="PCN">Pitcairn</option>
                                                                                <option value="POL">Poland</option>
                                                                                <option value="PRT">Portugal</option>
                                                                                <option value="PRI">Puerto Rico</option>
                                                                                <option value="QAT">Qatar</option>
                                                                                <option value="REU">Réunion</option>
                                                                                <option value="ROU">Romania</option>
                                                                                <option value="RUS">Russian Federation</option>
                                                                                <option value="RWA">Rwanda</option>
                                                                                <option value="BLM">Saint Barthélemy</option>
                                                                                <option value="SHN">Saint Helena, Ascension and Tristan da Cunha</option>
                                                                                <option value="KNA">Saint Kitts and Nevis</option>
                                                                                <option value="LCA">Saint Lucia</option>
                                                                                <option value="MAF">Saint Martin (French part)</option>
                                                                                <option value="SPM">Saint Pierre and Miquelon</option>
                                                                                <option value="VCT">Saint Vincent and the Grenadines</option>
                                                                                <option value="WSM">Samoa</option>
                                                                                <option value="SMR">San Marino</option>
                                                                                <option value="STP">Sao Tome and Principe</option>
                                                                                <option value="SAU">Saudi Arabia</option>
                                                                                <option value="SEN">Senegal</option>
                                                                                <option value="SRB">Serbia</option>
                                                                                <option value="SYC">Seychelles</option>
                                                                                <option value="SLE">Sierra Leone</option>
                                                                                <option value="SGP">Singapore</option>
                                                                                <option value="SXM">Sint Maarten (Dutch part)</option>
                                                                                <option value="SVK">Slovakia</option>
                                                                                <option value="SVN">Slovenia</option>
                                                                                <option value="SLB">Solomon Islands</option>
                                                                                <option value="SOM">Somalia</option>
                                                                                <option value="ZAF">South Africa</option>
                                                                                <option value="SGS">South Georgia and the South Sandwich Islands</option>
                                                                                <option value="SSD">South Sudan</option>
                                                                                <option value="ESP">Spain</option>
                                                                                <option value="LKA">Sri Lanka</option>
                                                                                <option value="SDN">Sudan</option>
                                                                                <option value="SUR">Suriname</option>
                                                                                <option value="SJM">Svalbard and Jan Mayen</option>
                                                                                <option value="SWZ">Swaziland</option>
                                                                                <option value="SWE">Sweden</option>
                                                                                <option value="CHE">Switzerland</option>
                                                                                <option value="SYR">Syrian Arab Republic</option>
                                                                                <option value="TWN">Taiwan, Province of China</option>
                                                                                <option value="TJK">Tajikistan</option>
                                                                                <option value="TZA">Tanzania, United Republic of</option>
                                                                                <option value="THA">Thailand</option>
                                                                                <option value="TLS">Timor-Leste</option>
                                                                                <option value="TGO">Togo</option>
                                                                                <option value="TKL">Tokelau</option>
                                                                                <option value="TON">Tonga</option>
                                                                                <option value="TTO">Trinidad and Tobago</option>
                                                                                <option value="TUN">Tunisia</option>
                                                                                <option value="TUR">Turkey</option>
                                                                                <option value="TKM">Turkmenistan</option>
                                                                                <option value="TCA">Turks and Caicos Islands</option>
                                                                                <option value="TUV">Tuvalu</option>
                                                                                <option value="UGA">Uganda</option>
                                                                                <option value="UKR">Ukraine</option>
                                                                                <option value="ARE">United Arab Emirates</option>
                                                                                <option value="GBR">United Kingdom</option>
                                                                                <option value="USA">United States</option>
                                                                                <option value="UMI">United States Minor Outlying Islands</option>
                                                                                <option value="URY">Uruguay</option>
                                                                                <option value="UZB">Uzbekistan</option>
                                                                                <option value="VUT">Vanuatu</option>
                                                                                <option value="VEN">Venezuela, Bolivarian Republic of</option>
                                                                                <option value="VNM">Viet Nam</option>
                                                                                <option value="VGB">Virgin Islands, British</option>
                                                                                <option value="VIR">Virgin Islands, U.S.</option>
                                                                                <option value="WLF">Wallis and Futuna</option>
                                                                                <option value="ESH">Western Sahara</option>
                                                                                <option value="YEM">Yemen</option>
                                                                                <option value="ZMB">Zambia</option>
                                                                                <option value="ZWE">Zimbabwe</option>
                                                                            
                </Field>
                {
                    this.props.touched.country
                    && this.props.errors.country
                    && <p className="help-block">
                        {this.props.errors.country}
                    </p>
                }
            </div>
        </div>
    );

    renderCityForm = () => (
        <div className="col-sm-3">
            <div className={
                this.props.touched.city ?
                    (this.props.errors.city
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    City
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="city"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.city
                    && this.props.errors.city
                    && <p className="help-block">
                        {this.props.errors.city}
                    </p>
                }
            </div>
        </div>
    );

    renderStateForm = () => (
        <div className="col-sm-3">
            <div className={
                this.props.touched.state ?
                    (this.props.errors.state
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    State/Province
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="state"
                    disabled={!!this.props.isReviewForm}
                />
                {
                    this.props.touched.state
                    && this.props.errors.state
                    && <p className="help-block">
                        {this.props.errors.state}
                    </p>
                }
            </div>
        </div>
    );

    renderZipcodeForm = () => (
        <div className="col-sm-3">
            <div className={
                this.props.touched.zipcode ?
                    (this.props.errors.zipcode
                        ? "has-error form-group"
                        : "has-success form-group")
                    : "form-group"
            }>
                <label>
                    Zip/Postal Code
                    <span
                        className="required"
                        aria-required="true">
                        *
                    </span>
                </label>
                <Field
                    type="text"
                    className="form-control"
                    name="zipcode"
                    disabled={!!this.props.isReviewForm}
                    onBlur={e => this.props.collapseForm(2)}
                />
                {
                    this.props.touched.zipcode
                    && this.props.errors.zipcode
                    && <p className="help-block">
                        {this.props.errors.zipcode}
                    </p>
                }
                
            </div>
        </div>
    );
    
    render(){
    return (
        <Form
            action="#"
            id="submit_form"
            onSubmit={this.props.handleSubmit}
        >
            <div className="form-wizard">
                <div className="form-body">
                    <div className={"tab-content "+(this.props.isReviewForm ? "review" : "")}>
                        {Object.keys(this.props.errors).length > 0 &&
                        Object.keys(this.props.errors).length === Object.keys(this.props.touched).length &&
                        <div
                            className="alert alert-danger display-none sm-bottom0 error-popup-show"
                            style={{display: 'block'}}
                        >
                            <button
                                className="close"
                                data-dismiss="alert"
                            />
                            You have some form errors. Please check below.
                        </div>
                        }
                        <div className="tab-pane active" id="tab1">
                            <div className={`form-section ${(this.props.collapsedForms.indexOf(1) > -1 && !this.props.errors.name && !this.props.errors.lname && !this.props.errors.email && !this.props.errors.gender && !this.props.errors.birthdate) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => this.props.toggleCollapse(1)}>
                                Let's start from the basics
                                
                                
                                {this.props.collapsedForms.indexOf(1) > -1 ?
                                <i className="zmdi zmdi-chevron-down"></i>
                                :
                                <i className="zmdi zmdi-chevron-up"></i>
                                }
                               
                                </h3>
                                <div className="form-section-body" style={{height: (this.props.collapsedForms.indexOf(1) > -1 && !this.props.errors.name &&!this.props.errors.lname && !this.props.errors.email && !this.props.errors.gender && !this.props.errors.birthdate) ? '0px' : 'initial'}}>
                                   
                                    <div className="row">
                                        {this.renderFirstNameForm()}
                                        {this.renderMiddleNameForm()}
                                        {this.renderLastNameForm()}
        
                                    </div>
                                    <div className="row">
                                        {this.renderEmailForm()}
                                        
                                        {this.renderGenderForm()}
                                        {this.renderDobForm()}
                                    </div>
                                    
                                </div>
                            </div>
                            
                            <div className={`form-section ${(this.props.collapsedForms.indexOf(2) > -1 && !this.props.errors.address && !this.props.errors.country && !this.props.errors.state && !this.props.errors.city && !this.props.errors.zipcode) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => this.props.toggleCollapse(2)}>
                                Mailing Address
                                
                                {this.props.collapsedForms.indexOf(2) > -1 ?
                                <i className="zmdi zmdi-chevron-down"></i>
                                :
                                <i className="zmdi zmdi-chevron-up"></i>
                                }
                               
                                </h3>
                                    <div className="form-section-body" style={{height: (this.props.collapsedForms.indexOf(2) > -1 && !this.props.errors.address && !this.props.errors.country && !this.props.errors.state && !this.props.errors.city && !this.props.errors.zipcode) ? '0px' : 'initial'}}>
                                
                                    <div className="row">
                                        {this.renderAddressForm()}
                                         {this.renderCountryForm()}
                                        
                                        {this.renderStateForm()}
                                        
                                        
                                        {this.renderAddress2Form()}
                                        {this.renderCityForm()}
                                        {this.renderZipcodeForm()}
                                    </div>
                                </div>
                            </div>
                            
                            <div className={`form-section ${(this.props.collapsedForms.indexOf(3) > -1 && !this.props.errors.phonetype && !this.props.errors.phonecountry && !this.props.errors.phone) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => this.props.toggleCollapse(3)}>
                                Contact Information
                                
                                {this.props.collapsedForms.indexOf(3) > -1 ?
                                <i className="zmdi zmdi-chevron-down"></i>
                                :
                                <i className="zmdi zmdi-chevron-up"></i>
                                }
                               
                                </h3>
                            <div className="form-section-body" style={{height: (this.props.collapsedForms.indexOf(3) > -1 && !this.props.errors.phonetype && !this.props.errors.phonecountry && !this.props.errors.phone) ? '0px' : 'initial'}}>
                                
                                    <div className="row">
                                        {this.renderContactTypeForm()}
                                         {this.renderContactCodeForm()}
                                        
                                        {this.renderContactNumberForm()}
                                       
                                    </div>
                                </div>
                            </div>
                            
                            
                            <div className={`form-section ${(this.props.collapsedForms.indexOf(4) > -1 && !this.props.errors.ecrel && !this.props.errors.ecname && !this.props.errors.ectype && !this.props.errors.eccountry && !this.props.errors.ecnumber) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => this.props.toggleCollapse(4)}>
                                Emergency Contact Information
                                
                                {this.props.collapsedForms.indexOf(4) > -1 ?
                                <i className="zmdi zmdi-chevron-down"></i>
                                :
                                <i className="zmdi zmdi-chevron-up"></i>
                                }
                               
                                </h3>
                            <div className="form-section-body" style={{height: (this.props.collapsedForms.indexOf(4) > -1 && !this.props.errors.ecrel && !this.props.errors.ecname && !this.props.errors.ectype && !this.props.errors.eccountry && !this.props.errors.ecnumber) ? '0px' : 'initial'}}>
                                
                          
                            
                                    <div className="row">
                                        {this.renderECRelForm()}
                                         {this.renderECNameForm()}
                                    </div>
                                    <div className="row">
                                        {this.renderECTypeForm()}
                                        
                                        
                                        {this.renderECCountryForm()}
                                        {this.renderECNumberForm()}
                                    </div>
                                </div>
                            </div>
                            
                            {this.props.values.requireParent == "true" &&
                            <div className={`form-section ${(this.props.collapsedForms.indexOf(5) > -1 && !this.props.errors.prel && !this.props.errors.pname && !this.props.errors.ptype && !this.props.errors.pcountry && !this.props.errors.pnumber) ? 'hiddenFormSectionBody' : ''}`}>
                                <h3 className="form-heading" onClick={e => this.props.toggleCollapse(5)}>
                                Parent/Guardian Information
                                
                                {this.props.collapsedForms.indexOf(5) > -1 ?
                                <i className="zmdi zmdi-chevron-down"></i>
                                :
                                <i className="zmdi zmdi-chevron-up"></i>
                                }
                               
                                </h3>
                            <div className="form-section-body" style={{height: (this.props.collapsedForms.indexOf(5) > -1 && !this.props.errors.prel && !this.props.errors.pname && !this.props.errors.ptype && !this.props.errors.pcountry && !this.props.errors.pnumber) ? '0px' : 'initial'}}>
                                
                           
                            
                                    <div className="row">
                                        {this.renderPRelForm()}
                                         {this.renderPNameForm()}
                                    </div>
                                    <div className="row">
                                        {this.renderPTypeForm()}
                                        
                                        
                                        {this.renderPCountryForm()}
                                        {this.renderPNumberForm()}
                                    </div>
                                </div>
                            </div>
                            }
                            
                            
                            <div className="form-section">
                                <h3 className="form-heading">How did you hear about us?</h3>
                                    <div className="form-section-body">
                            
                                    <div className="row">
                                        {this.renderReferrerForm()}
                                    </div>
                                    
                                </div>
                            </div>
                            
                        </div>
                    </div>
                </div>
                {
                    !this.props.isReviewForm &&
                    <div className="form-actions sm-top50 onboarding-form-step">
                        <div className="row">
                            <div className="col-md-12 text-right">

                                <button
                                    className="btn btn-danger button-next btn-lg font-16"
                                    type="submit"
                                    disabled={this.props.isSubmitting}
                                    onClick={e => {
                                        this.props.findError();
                                        this.props.handleSubmit(e);
                                    }}
                                >
                                    Continue
                                    <i className="m-icon-swapright m-icon-white"/>
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </div>
        </Form>
    )
    }
};


const Form1 = withFormik({

    mapPropsToValues({ parentProps,
                         name,
                         email,
                         phone,
                         gender,
                         birthdate,
                         address,
                         address2,
                         city,
                         country,
                         state,
                         zipcode,
                        phonecountry,
                        phonetype,
                        ecrel,
                        ecname,
                        ectype,
                        eccountry,
                        ecnumber,
                        prel,
                        pname,
                        ptype,
                       pcountry,
                        pnumber,
                        referrer,
                        mname,
                        lname
    })
    {
        return {
            name: name || parentProps.profile.name || '',
            mname: mname || parentProps.profile.mname || '',
            lname: lname || parentProps.profile.lname || '',
            email: email || parentProps.profile.email || '',
            phone: phone || parentProps.profile.phone || '',
            gender: gender || parentProps.profile.gender || '',
            birthdate: birthdate || parentProps.profile.birthdate || '',
            city: city || parentProps.profile.city || '',
            country: country || parentProps.profile.country || '',
            state: state || parentProps.profile.district || '',
            zipcode: zipcode || parentProps.profile.postalCode || '',
            address: address || parentProps.profile.address1 || '',
            address2: address2 || parentProps.profile.address2 || '',
            phonetype: phonetype || parentProps.profile.phonetype || '',
            phonecountry: phonecountry || parentProps.profile.phonecountry || '',
            ecrel: ecrel || parentProps.profile.ecrel || '',
            ecname: ecname || parentProps.profile.ecname || '',
            ectype: ectype || parentProps.profile.ectype || '',
            eccountry: eccountry || parentProps.profile.eccountry || '',
            ecnumber: ecnumber || parentProps.profile.ecnumber || '',
            referrer: referrer || parentProps.profile.referrer || '',
            prel: prel || parentProps.profile.prel || '',
            pname: pname || parentProps.profile.pname || '',
            ptype: ptype || parentProps.profile.ptype || '',
            pcountry: pcountry || parentProps.profile.pcountry || '',
            requireParent: false,
            pnumber: pnumber || parentProps.profile.pnumber || '',
        };
    },

    validationSchema: Yup.object().shape({
        name: Yup.string().required('Name is required'),
        lname: Yup.string().required('Last name is required'),
        email: Yup.string().email('Email not valid').required('Email is required'),
        phone: Yup.string().min(9, 'Phone not valid').required('Phone is required'),
        gender: Yup.string().required('Choose your gender'),
        birthdate: Yup.date().max(new Date(), 'Birthdate not valid'),
        city: Yup.string().required('City is required'),
        address: Yup.string().required('Address is required'),
        state: Yup.string().required('State/Province is required'),
        zipcode: Yup.string().required('Zip/Postal Code is required'),
        country: Yup.string().required('Country Code is required'),
        phonetype: Yup.string().required('Type is required'),
        
        ecrel: Yup.string().required('required'),
        ecname: Yup.string().required('required'),
        ectype: Yup.string().required('required'),
        eccountry: Yup.string().required('required'),
        ecnumber: Yup.string().required('required'),
        requireParent: Yup.boolean(),
        
        
        prel: Yup.string().when('requireParent', {
            is: true,
            then: Yup.string().required('required')
        }),
        pname: Yup.string().when('requireParent', {
            is: true,
            then: Yup.string().required('required')
        }),
        ptype: Yup.string().when('requireParent', {
            is: true,
            then: Yup.string().required('required')
        }),
        pcountry: Yup.string().when('requireParent', {
            is: true,
            then: Yup.string().required('required')
        }),
        pnumber: Yup.string().when('requireParent', {
            is: true,
            then: Yup.string().required('required')
        })
        

    }),

    handleSubmit(values, {setErrors, errors, setStatus, setSubmitting, props}) {
        props.findError();
        setTimeout(() => {
            if (values.email === 'test@test.io') {
                setErrors({ email: 'This email is already token' })
            } else {


                props.onBasicInfoUpdate(
                    {
                        name: values.name,
                        mname: values.mname,
                        lname: values.lname,
                        email: values.email,
                        gender: values.gender,
                        birthdate: values.birthdate,
                        ecrel: values.ecrel,
                        ecname: values.ecname,
                        ectype: values.ectype,
                        eccountry: values.eccountry,
                        ecnumber: values.ecnumber,
                        prel: values.prel,
                        pname: values.pname,
                        ptype: values.ptype,
                        pcountry: values.pcountry,
                        pnumber: values.pnumber,
                        referrer: values.referrer,
                        phone: values.phone,
                        phonetype: values.phonetype,
                        phonecountry: values.phonecountry,
                        city: values.city,
                        district: values.state,
                        postalCode: values.zipcode,
                        address1: values.address,
                        country: values.country,
                    }
                );
                // props.receivedValues(values);
                props.receiveNextFormNumber(2);
            }
        }, 200)
    }
})(renderForm1);

Form1.propTypes = {
    receiveNextFormNumber: PropTypes.func.isRequired,
    name: PropTypes.string,
    email: PropTypes.string,
    gender: PropTypes.string,
    birthdate: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.instanceOf(Date)
    ]),
    phone: PropTypes.string,
    city: PropTypes.string,
    country: PropTypes.string,
    district: PropTypes.string,
    postalCode: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    address1: PropTypes.string,
};

export default Form1;


// WEBPACK FOOTER //
// ./src/components/onBoarding/Form1.js